exports.formatNumberAsBRLCurrency = (num) => {
    const format = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    };
    return (num).toLocaleString('pt-BR', format);
};